import axios from 'axios'
import Constants from '../../constants'
let instance = null

class APIService {
  constructor() {
    if (!instance) {
      instance = this
    }

    this.url = Constants.CEZY_API_BASE_URL
    return instance
  }

  async loginUser(user) {
    return axios.post(`${this.url}/webapi/auth`, user, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods':
          'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
        'Content-Type': 'application/json'
      }
    })
  }

  async getTokenFromMicrosoftJwt(jwt) {
    return axios.get(`${this.url}/webapi/auth/token`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
        'Content-Type': 'application/json'
      }
    })
  }

  async getJudetApi() {
    const url = `${this.url}/webapi/pub/geo/counties`
    const response = await axios.get(url)
    return response.data
  }

  async getLocalitateApi(id) {
    const url = `${this.url}/webapi/pub/geo/counties/${id}/localities`
    const response = await axios.get(url)
    return response.data
  }

  async getAllEntities() {
    const url = `${this.url}/webapi/entities/`
    return axios.get(url, this._getDefaultConfig())
  }

  async getAllEntries(entityId) {
    const url = `${this.url}/webapi/entities/${entityId}/data`
    return axios.get(url, this._getDefaultConfig())
  }

  async getEntity(entityId) {
    const url = `${this.url}/webapi/entities/${entityId}`
    return axios.get(url, this._getDefaultConfig())
  }

  async getEntry(entityId, entryId) {
    const url = `${this.url}/webapi/entities/${entityId}/data/${entryId}`
    return axios.get(url, this._getDefaultConfig())
  }

  async createEntry(entityId, newEntry) {
    const url = `${this.url}/webapi/entities/${entityId}/data`
    return axios.post(url, newEntry, this._getDefaultConfig())
  }

  async updateEntry(entityId, entryId, updatedEntry) {
    const url = `${this.url}/webapi/entities/${entityId}/data/${entryId}`
    return axios.put(url, updatedEntry, this._getDefaultConfig())
  }

  async deleteEntry(entityId, entryId) {
    const url = `${this.url}/webapi/entities/${entityId}/data/${entryId}`
    return axios.delete(url, this._getDefaultConfig())
  }

  async requestApiTest(entityId) {
    const url = `${this.url}/webapi/entities/${entityId}/forms/simple-view`
    return axios.get(url, this._getDefaultConfig())
  }

  _getDefaultConfig() {
    return {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }
  }

  // TODO: Replace static URL
  async getQuery(queryId) {
    // console.log("AICI IN API SERVICE");
    const url = `${this.url}/webapi/queries/${queryId}`
    return axios.get(url, this._getDefaultConfig())
  }

  async getQueryData(queryId) {
    const url = `${this.url}/webapi/queries/${queryId}/data`
    return axios.get(url, null, this._getDefaultConfig())
  }

  async getQueryDataWithFilters({
    queryId,
    hardFilters,
    pageIndex,
    pageSize,
    filter,
    descending,
    sortBy,
    columnsFilters
  }) {
    var url = `${this.url}/webapi/queries/${queryId}/data?`
    if (pageIndex != null) {
      url += `pageIndex=${pageIndex}&`
    }
    if (pageSize != null) {
      url += `pageSize=${pageSize}&`
    }
    if (filter != null) {
      url += `filter=${filter}&`
    }
    if (sortBy != null) {
      let sortType = descending ? 'desc' : 'asc'
      url += `sortingColumnKey=${sortBy}&sortingType=${sortType}`
    }
    var customFilters = {}
    if (columnsFilters != null && Object.keys(columnsFilters).length > 0) {
      customFilters.columnsFilters = columnsFilters
      //return axios.post(url, columnFiltersObject, this._getDefaultConfig());
    }
    if (hardFilters != null) {
      customFilters.hardFilters = hardFilters
    }
    if (url[url.length - 1] === '?' || url[url.length - 1] === '&')
      url = url.substring(0, url.length - 1)

    if (customFilters != {})
      return axios.post(url, customFilters, this._getDefaultConfig())
    return axios.get(url, this._getDefaultConfig())
  }

  async getForm(entityId, formKey) {
    const url = `${this.url}/webapi/entities/${entityId}/forms/${formKey}`
    return axios.get(url, this._getDefaultConfig())
  }

  async getFormById(formId) {
    const url = `${this.url}/webapi/forms/${formId}`
    return axios.get(url, this._getDefaultConfig())
  }

  async getAllAttachments(entityId, entryId) {
    const url = `${this.url}/webapi/attachments/entities/${entityId}/data/${entryId}`
    return axios.get(url, this._getDefaultConfig())
  }

  async deleteAttachments(fileId) {
    const url = `${this.url}/webapi/attachments/delete?fileId=${fileId}`
    const config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods':
          'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }
    return axios.delete(url, config)
  }

  async uploadAttachment(entityId, entryId, formData) {
    const url = `${this.url}/webapi/attachments/entities/${entityId}/data/${entryId}/upload`
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }
    return axios.post(url, formData, config)
  }

  async downloadPdf(entityId, entryId, pdfTemplateId) {
    const url = `${this.url}/webapi/pdfGenerator/download?pdfTemplateId=${pdfTemplateId}&entityId=${entityId}&entryId=${entryId}`
    const config = {
      responseType: 'arraybuffer',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }
    return axios.get(url, config)
  }

  async downloadAttachment(fileId) {
    const url = `${this.url}/webapi/attachments/download?fileId=${fileId}`
    //daca nu dam response type array buffer nu o sa functioneze corect download
    const config = {
      responseType: 'arraybuffer',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }
    return axios.get(url, config)
  }

  async getFunctionValue(entityId, entryId, functionName, functionArgs) {
    const url = `${this.url}/webapi/entities/${entityId}/data/${entryId}/function`
    const request = {
      functionName,
      functionArgs: functionArgs || []
    }

    return axios.post(url, request, this._getDefaultConfig())
  }

  async getFieldSuggestions(entityId, field) {
    return axios.get(
      `${this.url}/webapi/entities/${entityId}/suggestions/${field}`,
      this._getDefaultConfig()
    )
  }
}

const serviceInstance = new APIService()
Object.freeze(APIService)
export default serviceInstance
